<template>
  <div>
    <BtnLauch :action="lauchScript" :isLoading="isLoading" :time="time" title="Compare" />
    <pre style="white-space: inherit;color: white" v-html="fileContent"></pre>
    <RenderResult v-if="result" :datas="result" />
  </div>
</template>
<script>
import axios from "axios";
import BtnLauch from "./BtnLauch.vue";
import RenderResult from "./RenderResult.vue";
import oldVue from "../../home/accueil/old.vue";

export default {
  props: {
    scan: {
      require: true,
    },
    positions: {
      require: true,
    },
    user: {
      require: true,
    },
  },
  data() {
    return {
      isLoading: false,
      fileContent: "",
      result: "",
      time: 0,
      timer: null,
    };
  },
  mounted() {
    this.getFileContent();
    setInterval(() => {
      this.getFileContent();
    }, 3000);
  },
  watch: {
    result(oldVue, newValue) {
      console.log(newValue);
    },
  },
  methods: {
    async lauchScript() {
      this.isLoading = true;
      this.resetTimer();
      this.startTimer();
      try {
        await this.scan(`/api/v1/compare_platforms?api_token=${this.user.api_token}`).then((response) => (this.result = response.data.result));
        this.getFileContent();
      } catch (error) {
        console.error(error);
      } finally {
        this.stopTimer();
        this.isLoading = false;
      }
    },
    async getFileContent() {
      if (this.user !== null && this.user !== undefined) {
        try {
          const response = await axios.get(`/scanner/showFile/${this.user.id}/log_ComparePlatforms`);
          this.fileContent = response.data.replace(/{"date":/g, '</br> {"date":').replace(/{"src"/g, '</br> {"src"');
        } catch (error) {
          console.error(error);
        } finally {
        }
      }
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.time++;
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
      //   this.resetTimer();
    },
    resetTimer() {
      this.time = 0;
    },
  },
  components: { BtnLauch, RenderResult },
};
</script>
